import { ArrowMediumDown32 } from '@packages/themes/icons';
import { styled } from '@mui/material';
import {
  type GlycerinButtonClickPayload,
  type GlycerinFormSubmitClickPayload,
} from '@packages/tracking/src/types/payloads';
import {
  type GTMEventGlycerinFormSubmitClick,
  type GTMEventGlycerinButtonClick,
} from '@packages/tracking/src/types/events';
import { useTracking } from '@packages/tracking/src/hooks/useTracking/useTracking';
import type { FlatIconButtonProps } from '../../FlatIconButton';
import { FlatIconButton } from '../../FlatIconButton';

export interface RotatingArrowButtonProps extends FlatIconButtonProps {
  rotated: boolean;
  clickTrackingProps?: GlycerinButtonClickPayload | GlycerinFormSubmitClickPayload;
}

export const RotatingArrowButton = styled(
  ({ clickTrackingProps, onClick, rotated, ...props }: RotatingArrowButtonProps) => {
    const dispatchGTMEvent = useTracking();
    const { type } = props;
    const { category, target, detail, label, placement, variantIds, custom } =
      clickTrackingProps ?? {};
    return (
      <FlatIconButton
        onClick={(event) => {
          if (type === 'submit') {
            dispatchGTMEvent<GTMEventGlycerinFormSubmitClick>({
              event: 'FormSubmitClick',
              FormSubmitClickData: {
                category: category ?? 'form-submit-click',
                target,
                detail,
                label,
                placement,
                formId:
                  clickTrackingProps && 'formId' in clickTrackingProps
                    ? clickTrackingProps.formId
                    : undefined,
                variantIds,
                custom,
              },
            });
          } else {
            dispatchGTMEvent<GTMEventGlycerinButtonClick>({
              event: 'ButtonClick',
              ButtonClickData: {
                category: category ?? 'rotating-arrow-button-click',
                target,
                detail,
                label,
                placement,
                variantIds,
                custom,
              },
            });
          }
          if (onClick) {
            onClick(event);
          }
        }}
        {...props}
        sx={{ p: 0 }}
      >
        <ArrowMediumDown32 />
      </FlatIconButton>
    );
  },
)(({ theme, rotated }) => ({
  transform: rotated ? 'rotate(180deg)' : 'rotate(0deg)',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
}));
